export const TRADES_START_DATE = new Date("May 31, 2021 00:00:00");
export const TRADES_END_DATE = new Date(new Date().setHours(23,59,59,99));
